import * as React from 'react';

import type { AnalyticsClient } from './analytics-client';
import { NewAnalyticsContext } from './new-analytics-context';

export const useAnalyticsClient = (): AnalyticsClient => React.useContext(NewAnalyticsContext);
